<div class="ds-gallery" *ngIf="flagLoaded; else skeleton">
    <button
        type="button"
        class="ds-gallery__item"
        *ngFor="let img of imagenesGaleria; trackBy: trackByImagen"
        (click)="verImagen(img)"
    >
        <img [src]="img.safeUrl" [alt]="img.nombre" loading="lazy" />
        <span class="ds-gallery__name">{{ img.nombre }}</span>
    </button>
</div>

<ng-template #skeleton>
    <div class="ds-gallery">
        <div class="ds-gallery__item ds-gallery__item--skeleton" *ngFor="let item of skeletonItems">
            <span class="ds-skeleton ds-gallery__skeleton-img"></span>
            <span class="ds-skeleton ds-gallery__skeleton-name"></span>
        </div>
    </div>
</ng-template>
